module.exports = __webpack_public_path__ + "img/mingyong42.a85db937.png";